import { Button, Dialog } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import type { ApiError } from '../../../lib/errors';
import { LoiTrongHop } from '../../tenant/components/phan-form';
import type { ApiKey } from '../types';

/**
 * Hộp xác nhận thu hồi khoá (`DELETE /api/v1/api-keys/{id}`). Thân nói hậu
 * quả — hệ thống dùng khoá bị từ chối trong vài giây — và rằng không hoàn tác
 * được. Lỗi hiện trong hộp, hộp không đóng. `404` là khoá đã không còn (phiên
 * khác vừa thu hồi hay xoá): hộp nói vậy và bỏ nút thu hồi, vì bấm lại vẫn hỏng.
 */

/** Mốc tách câu quanh tiền tố khoá, để tiền tố hiện bằng phông đơn cách. */
const MOC = '\u0000';
export function HopThuHoiKhoaApi({
  open,
  khoa,
  dangChay,
  loi,
  onClose,
  onXacNhan,
}: {
  open: boolean;
  /** Giữ nguyên khi hộp đang đóng, để tiêu đề không nháy trống lúc mờ dần. */
  khoa: ApiKey | null;
  dangChay: boolean;
  loi: unknown;
  onClose: () => void;
  onXacNhan: (khoa: ApiKey) => void;
}) {
  const { t } = useT();
  const dichLoi = useLoi();
  const khongCon = (loi as ApiError | null)?.status === 404;
  const [truoc, sau] = t('khoaApi.xnThan', { tienTo: MOC }).split(MOC);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('khoaApi.xnTieuDe', { ten: khoa?.name ?? '' })}
      width={480}
      destroyOnHidden
      footer={
        <div className="flex flex-wrap justify-end gap-3">
          <Button variant="outline" size="md" onClick={onClose}>
            {khongCon ? t('chung.dong') : t('chung.huy')}
          </Button>
          {!khongCon && (
            <Button variant="destructive" size="md" loading={dangChay} onClick={() => khoa && onXacNhan(khoa)}>
              {dangChay ? t('khoaApi.dangThuHoi') : t('khoaApi.thuHoiKhoa')}
            </Button>
          )}
        </div>
      }
    >
      <div className="space-y-3 pt-2">
        <p className="text-sm leading-relaxed text-content-secondary">
          {truoc}
          <code className="font-mono text-xs text-content-primary">{khoa?.key_prefix}</code>
          {sau}
        </p>
        {Boolean(loi) && <LoiTrongHop>{khongCon ? t('khoaApi.loiKhongCon') : dichLoi(loi)}</LoiTrongHop>}
      </div>
    </Dialog>
  );
}
